import styled from 'styled-components';
import { Button } from 'ui/button';
import { colors, spacing } from 'ui/theme';

export const DatePickerContainer = styled.div`
  position: relative;
  width: 100%;
  padding: ${spacing.half} 0;
`;

export const DatePickerWrapper = styled.div`
  position: absolute;
  right: 367px;
  top: ${spacing.x4};
  background-color: ${colors.white};
  width: 100%;
  z-index: 1000;
`;

export const FlexMetricsButton = styled(Button)`
  width: 100%;
`;

export const InnerButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.fiveEights};
  width: 100%;
`;
